import { extractUiPos } from 'pages/EditorPage/RubricsPortfolioTemplatesEditor/PortfolioTemplatesEditor/useMakeDraggable/uiPosUtils';

const sortPartsByUiPos = subtopicKey => (a, b) =>
  extractUiPos(a, subtopicKey) - extractUiPos(b, subtopicKey);

export default sortPartsByUiPos;
